import React from 'react';
import classnames from 'classnames';
import styles from './GridCol.scss';

var GridCol = function GridCol(_ref) {
  var _ref$xl = _ref.xl,
      xl = _ref$xl === void 0 ? 12 : _ref$xl,
      lg = _ref.lg,
      _ref$sm = _ref.sm,
      sm = _ref$sm === void 0 ? 4 : _ref$sm,
      xs = _ref.xs,
      children = _ref.children,
      className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(className, styles.col, styles["col_xl--".concat(xl)], styles["col_lg--".concat(lg || xl)], styles["col_sm--".concat(sm)], styles["col_xs--".concat(xs || sm)])
  }, children);
};

export default GridCol;